/* import __COLOCATED_TEMPLATE__ from './brand-identity-avatar.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import templateOnlyComponent from '@ember/component/template-only';
import { type BrandIdentityData } from 'embercom/components/automation/fin-ai-agent/settings/audience/types';

interface Signature {
  Element: HTMLElement;
  Args: {
    brandData: BrandIdentityData | undefined;
    defaultBrandData: BrandIdentityData | undefined;
  };
}

const BrandIdentityAvatar = templateOnlyComponent<Signature>();
export default BrandIdentityAvatar;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Automation::FinAiAgent::Settings::Audience::BrandIdentityAvatar': typeof BrandIdentityAvatar;
  }
}
